import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepPaymentDetails = (state) => state.get('stepPaymentDetails');

const makeSelectStepPaymentDetails = () =>
  createSelector(selectStepPaymentDetails, (stepPaymentDetailsState) => ({
    paymentTo: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'paymentTo']),
      ''
    ),
    paymentVia: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'paymentVia']),
      ''
    ),
    title: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'title']),
      ''
    ),
    firstName: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'firstName']),
      ''
    ),
    lastName: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'lastName']),
      ''
    ),
    addressLine1: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'addressLine1']),
      ''
    ),
    addressLine2: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'addressLine2']),
      ''
    ),
    country: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'country']),
      ''
    ),
    state: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'state']),
      ''
    ),
    city: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'city']),
      ''
    ),
    postalZipCode: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'postalZipCode']),
      ''
    ),
    mobile: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'mobile']),
      ''
    ),
    //------------
    bankTypeCode: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bankTypeCode']),
      ''
    ),
    bankCodeOrRoutingNumber: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bankCodeOrRoutingNumber']),
      ''
    ),
    isValidate: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'isValidate']),
      ''
    ),
    bank: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bank']),
      ''
    ),
    bankAddress: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bankAddress']),
      ''
    ),
    bankSuburbOrCity: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bankSuburbOrCity']),
      ''
    ),
    bankPostcode: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bankPostcode']),
      ''
    ),
    bankBranch: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bankBranch']),
      ''
    ),
    bankAccountName: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bankAccountName']),
      ''
    ),
    bankAccountNumber: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'bankAccountNumber']),
      ''
    ),
    swiftCode: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'swiftCode']),
      ''
    ),
    iban: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'iban']),
      ''
    ),
    isVerified: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'isVerified']),
      ''
    ),
    isCheckPayment: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'isCheckPayment']),
      ''
    ),
    paymentTypeOptions: mapWithDefault(
      stepPaymentDetailsState,
      () => stepPaymentDetailsState.getIn(['form', 'paymentTypeOptions']),
      ''
    ),
  }));

const makeSelectStepPaymentDetailsErrors = () =>
  createSelector(selectStepPaymentDetails, (stepPaymentDetailsState) =>
    mapWithDefault(stepPaymentDetailsState, () => stepPaymentDetailsState.get('currentStep'), [])
  );

export {
  makeSelectStepPaymentDetails,
  makeSelectStepPaymentDetailsErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/selectors.js